/**
 * page : 측량 견적 문의
 */

import { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import * as zy from '../common/zeroyear-1.0.0';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Swal from "sweetalert2";
import { Paging } from '../components/Paging';
let sessionStorage = window.sessionStorage;



const dataObject = {ESTMTE_DV: '10', ESTMTE_REG_NM: '', ESTMTE_PW: '', ESTMTE_TITLE: '', ESTMTE_CONTENT: '성   명 :\n연락처 :\n이메일 :\n-----------------------------------\n문의내용 :'};
export default function SurveyEstimatePage () {
    const [admin, setAdmin] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [estmteList, setEstmteList] = useState([]);
    const [data, setData] = useState(dataObject);
    const [clickEst, setClickEst] = useState(null);
    const [myPw, setMyPw] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalPw, setShowModalPw] = useState(false);
    const [validated, setValidated] = useState(false);
    const [count, setCount] = useState(0); //아이템 총 개수
    const [currentpage, setCurrentpage] = useState(1); //현재페이지
    const [postPerPage] = useState(10); //페이지당 아이템 개수
    const [indexOfLastPost, setIndexOfLastPost] = useState(0);
    const [indexOfFirstPost, setIndexOfFirstPost] = useState(0);
    const [currentPosts, setCurrentPosts] = useState(0);
    const selectAll = () => {
        zy.select('selectEstmteAll', ['10'],(item) => {
            setEstmteList(item);
            setLoading(false);
            setCount(estmteList.length);
            setIndexOfLastPost(currentpage * postPerPage);
            setIndexOfFirstPost(indexOfLastPost - postPerPage);
            setCurrentPosts(estmteList.slice(indexOfFirstPost, indexOfLastPost));
        });
    };
    const setPage = (e) => { setCurrentpage(e); };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, [currentpage, indexOfFirstPost, indexOfLastPost, estmteList, postPerPage]);
    /**
     * close modal
     */
    const closeModal = () => {
        setValidated(false);
        setShowModal(false);
    };
    /**
     * open modal
     */
    const openModal = () => {
        setValidated(false);
        setShowModal(true);
    };
    /**
     * close modal pw
     */
    const closeModalPw = () => {
        setShowModalPw(false);
        setClickEst('');
        setMyPw('');
    };
    /**
     * open modal pw
     */
    const openModalPw = () => {
        setShowModalPw(true);
    };
    /**
     * 작성자 change event
     */
    const changeRegNm = (event) => {
        setData({...data, ESTMTE_REG_NM: event?.target.value});
    }
    /**
     * 비밀번호 change event
     */
    const changePw = (event) => {
        setData({...data, ESTMTE_PW: event?.target.value});
    }
    /**
     * my 비밀번호 change event
     */
    const changeMyPw = (event) => {
        setMyPw(event?.target.value);
    }
    /**
     * 제목 change event
     */
    const changeTitle = (event) => {
        setData({...data, ESTMTE_TITLE: event?.target.value});
    }/**
     * 내용 change event
     */
    const changeContent = (event) => {
        setData({...data, ESTMTE_CONTENT: event?.target.value});
    }

    /**
     * 등록 event handler
     */
    const saveDesign = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // validate
            event.preventDefault();
            event.stopPropagation();
        } else {
            // 저장
            event.preventDefault();
            event.stopPropagation();
            zy.create('insertEstmte', [
                data.ESTMTE_DV, data.ESTMTE_DV, data.ESTMTE_REG_NM, data.ESTMTE_PW, data.ESTMTE_TITLE, data.ESTMTE_CONTENT
            ], (item) => {
                if (item.affectedRows > 0) {
                    // 저장 완료
                    closeModal();
                    selectAll();
                }
            });
        }
        setValidated(true);
    };
    /**
     * check click pw
     */
    const checkPw = (event) => {
        let seq = event.target.getAttribute('data-seq')
        let est = estmteList.find((o) => o.ESTMTE_SEQ == seq);
        setClickEst(est);
        if (admin) {
            navigate(`/SurveyEstimateDetailRoute/${est.ESTMTE_SEQ}`);
            event.preventDefault();
            event.stopPropagation();
        } else {
            openModalPw();
        }
    };
    /**
     * confirm my pw
     */
    const checkMyPw = () => {
        if (clickEst.ESTMTE_PW === myPw) {
            navigate(`/SurveyEstimateDetailRoute/${clickEst.ESTMTE_SEQ}`);
        } else {
            Swal.fire({
                icon: "error",
                text: "비밀번호가 일치하지 않습니다.",
            }).then((res) => {
                if (res.isConfirmed) { }
                else{ }
            });
        }
    }
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">측량사업부</a></li>
                        <li>견적문의</li>
                    </ol>
                    <h2>견적문의</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-12">
                            <Table responsive="sm">
                                <thead>
                                    <tr>
                                        <th style={{width: '100px'}}>번호</th>
                                        <th style={{width: '150px'}}>분류</th>
                                        <th style={{width: '400px'}}>제목</th>
                                        <th style={{width: '180px'}}>작성자</th>
                                        <th style={{width: '280px'}}>작성일시</th>
                                        <th style={{width: '100px'}}>답변</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {estmteList.length === 0 ? (
                                    <tr><td style={{ textAlign: 'center' }} colSpan={6}>등록된 문의글이 없습니다.</td></tr>
                                ) : currentPosts.map((est) => (
                                    <tr key={est.ESTMTE_SEQ}>
                                        <td style={{width: '100px'}}>{est.ESTMTE_NO}</td>
                                        <td style={{width: '150px'}}>{est.ESTMTE_DV == '10' ? '측량' : ''}</td>
                                        <td style={{width: '400px'}}><Link data-seq={est.ESTMTE_SEQ} onClick={checkPw}>{est.ESTMTE_TITLE}</Link></td>
                                        <td style={{width: '180px'}}>{est.ESTMTE_REG_NM}</td>
                                        <td style={{width: '280px'}}>{est.REG_DTM}</td>
                                        <td style={{width: '100px'}}>{est.RE_COMP_YN === 'Y' ? '답변완료' : '미답변'}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                            <Paging page={currentpage} count={count} setPage={setPage} />
                        </div>
                    </div>
                    <button className="btn-normal" onClick={openModal} style={{float: 'right'}}>문의글 등록하기</button>
                </div>
            </section>

            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate validated={validated} onSubmit={saveDesign}>
                    <Modal.Header closeButton>
                    <Modal.Title>견적문의 - 측량</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_DV">
                            <Form.Label>분류</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                defaultValue={'측량'} disabled readOnly/>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_REG_NM">
                            <Form.Label>작성자</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=""
                                onChange={changeRegNm}
                                required/>
                            <Form.Control.Feedback type="invalid">작성자를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_PW">
                            <Form.Label>비밀번호</Form.Label>
                            <Form.Control
                                type="password"
                                onChange={changePw}
                                placeholder="비밀번호 입력 (8~12)"
                                maxLength={12}
                                required
                            />
                            <Form.Control.Feedback type="invalid">비밀번호를 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_TITLE">
                            <Form.Label>제목</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={changeTitle}
                                placeholder=""
                                required/>
                            <Form.Control.Feedback type="invalid">제목을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="d-input mb-3" controlId="ESTMTE_CONTENT">
                            <Form.Label>내용</Form.Label>
                            <Form.Control
                                as="textarea"
                                onChange={changeContent}
                                rows={6}
                                defaultValue={dataObject.ESTMTE_CONTENT}
                                required/>
                            <Form.Control.Feedback type="invalid">내용을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" onClick={closeModal}>닫기</button>
                            <button className="btn-normal" type="submit">등록완료</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
            <Modal 
                show={showModalPw}
                onHide={closeModalPw}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Modal.Header closeButton>
                <Modal.Title>비밀번호</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="d-input mb-3" controlId="ESTMTE_PW">
                        <Form.Label>비밀번호</Form.Label>
                        <Form.Control
                            type="password"
                            onChange={changeMyPw}
                            placeholder="비밀번호 입력 (8~12)"
                            maxLength={12}
                            required
                        />
                        <Form.Control.Feedback type="invalid">비밀번호를 입력해주세요.</Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn-cancel" onClick={closeModalPw}>닫기</button>
                    <button className="btn-normal" type="button" onClick={checkMyPw}>확인</button>
                </Modal.Footer>
            </Modal>
        </main>
        </>
    );
}